import React, {Component} from 'react';
import { Container,Carousel,Button,Row,Col, } from 'react-bootstrap';
import $ from 'jquery'
import Footer from './Footer'
import Fixed from './Fixed'
import './all.css'
import img1 from '../img/banner_zxs.png'
import zxs_syrq from '../img/zxs_syrq.png'
import zxs_ys from '../img/zxs_ys.png'
import zxs_jc from '../img/zxs_jc.png'
import hjqxyl from '../img/hjqxyl.png'
import zxs_kc from '../img/zxs_kc.png'
import zxs_glxt from '../img/zxs_glxt.png'
import zxs_app from '../img/zxs_app.png'
import zxs_jcb from '../img/zxs_jcb.png'
import zxs_sdx from '../img/zxs_sdx.png'
import npnj from '../img/npnj.png'
import rfjk from '../img/rfjk.png'
import nbpl from '../img/nbpl.png'
import fyyf from '../img/fyyf.png'
import dhjfxf from '../img/dhjfxf.png'
import pfjs from '../img/pfjs.png'
import hxjfgz from '../img/hxjfgz.png'
import xyxh from '../img/xyxh.png'
import shwstt from '../img/shwstt.png'
import bhst from '../img/bhst.png'
import shjrst from '../img/shjrst.png'
import jhmyxt from '../img/jhmyxt.png'
import jkglfw from '../img/jkglfw.png'
import weektc from '../img/weektc.png'
import mouthtc from '../img/mouthtc.png'
import bntc from '../img/bntc.png'
import yeartc from '../img/yeartc.png'
import gmlc from '../img/gmlc.png'
import zysx from '../img/zysx.png'
import './all.css'


class Consult extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    
    handleEnter = el=>{
        $('.'+el).css({'display':'block'})
    }
    handleOut = el=>{
        $('.'+el).css({'display':'none'})
    }
    render() {
        return (
            <div>
                <Row className='margin0'>
                    <img className="d-block w-100" src={img1} />
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={zxs_syrq} style={{marginTop:'5%'}}/>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={zxs_ys} style={{marginTop:'5%'}}/>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={zxs_jc} style={{marginTop:'5%'}}/>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={zxs_kc} style={{marginTop:'5%'}}/>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={zxs_glxt} style={{marginTop:'5%'}}/>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={zxs_app} style={{marginTop:'5%'}}/>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={zxs_jcb} style={{marginTop:'5%'}}/>
                    </Col>
                </Row>
                
                <Row>
                    <Col className='textCenter'>
                        <h4 style={{marginTop:'5%'}}>润方调理服务</h4>
                        <div style={{margin:'2% 0'}}>Meridians assessment service</div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover1')} onMouseLeave={()=>this.handleOut('hover1')}>
                            <img src={hjqxyl} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>解情绪压力</div>
                            <div className='rftl_item_msg'>舒缓压力，打开思路， 提升自我价值感，增进自信心，纾解忧郁情绪</div>
                            <div className='rftl_item_hover display_none hover1'>
                                <div className='rftl_item_hover_msg center'>舒缓压力，打开思路， 提升自我价值感，增进自信心，纾解忧郁情绪</div>
                                <div className='rftl_item_title_hover center'>解情绪压力</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover2')} onMouseLeave={()=>this.handleOut('hover2')}>
                            <img src={npnj} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>缓解尿频尿急</div>
                            <div className='rftl_item_msg'>有助于缓解良性前列腺增生产生的常见阻塞性症状和刺激性症状</div>
                            <div className='rftl_item_hover display_none hover2'>
                                <div className='rftl_item_hover_msg center'>有助于缓解良性前列腺增生产生的常见阻塞性症状和刺激性症状</div>
                                <div className='rftl_item_title_hover center'>缓解尿频尿急</div>
                            </div>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover3')} onMouseLeave={()=>this.handleOut('hover3')}>
                            <img src={npnj} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>缓解术后疼痛</div>
                            <div className='rftl_item_msg'>缓解手术后疼痛，预防伤口感染， 促进伤口恢复，纾解术后情绪压力</div>
                            <div className='rftl_item_hover display_none hover3'>
                                <div className='rftl_item_hover_msg center'>缓解手术后疼痛，预防伤口感染， 促进伤口恢复，纾解术后情绪压力</div>
                                <div className='rftl_item_title_hover center'>缓解术后疼痛</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover4')} onMouseLeave={()=>this.handleOut('hover4')}>
                            <img src={rfjk} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>呵护乳房健康</div>
                            <div className='rftl_item_msg'>舒缓由于良性乳腺增生带来的胀痛刺痛等不适</div>
                            <div className='rftl_item_hover display_none hover4'>
                                <div className='rftl_item_hover_msg center'>舒缓由于良性乳腺增生带来的胀痛刺痛等不适</div>
                                <div className='rftl_item_title_hover center'>呵护乳房健康</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover5')} onMouseLeave={()=>this.handleOut('hover5')}>
                            <img src={nbpl} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>缓解脑部疲劳</div>
                            <div className='rftl_item_msg'>检查你的异常经脉异常数据，有效预警疾病发生并，在短时间内通知您以及家人</div>
                            <div className='rftl_item_hover display_none hover5'>
                                <div className='rftl_item_hover_msg center'>检查你的异常经脉异常数据，有效预警疾病发生并，在短时间内通知您以及家人</div>
                                <div className='rftl_item_title_hover center'>缓解脑部疲劳</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover6')} onMouseLeave={()=>this.handleOut('hover6')}>
                            <img src={fyyf} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>新冠肺炎预防</div>
                            <div className='rftl_item_msg'>预防新冠肺炎，加强免疫系统，有助于保护细胞膜免受氧化代谢产物侵害</div>
                            <div className='rftl_item_hover display_none hover6'>
                                <div className='rftl_item_hover_msg center'>预防新冠肺炎，加强免疫系统，有助于保护细胞膜免受氧化代谢产物侵害</div>
                                <div className='rftl_item_title_hover center'>新冠肺炎预防</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover7')} onMouseLeave={()=>this.handleOut('hover7')}>
                            <img src={dhjfxf} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>淡化肌肤细纹</div>
                            <div className='rftl_item_msg'>激发肌肤的吸收和修复能力， 促进胶原蛋白产生，减少胶原蛋白流失</div>
                            <div className='rftl_item_hover display_none hover7'>
                                <div className='rftl_item_hover_msg center'>激发肌肤的吸收和修复能力， 促进胶原蛋白产生，减少胶原蛋白流失</div>
                                <div className='rftl_item_title_hover center'>淡化肌肤细纹</div>
                            </div>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover8')} onMouseLeave={()=>this.handleOut('hover8')}>
                            <img src={pfjs} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>加强皮肤紧实</div>
                            <div className='rftl_item_msg'>促进肌肤主动再生，有助于加强面部皮肤紧实，有弹力， 提升面部立体感，改善松弛下坠感</div>
                            <div className='rftl_item_hover display_none hover8'>
                                <div className='rftl_item_hover_msg center'>促进肌肤主动再生，有助于加强面部皮肤紧实，有弹力， 提升面部立体感，改善松弛下坠感</div>
                                <div className='rftl_item_title_hover center'>加强皮肤紧实</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover9')} onMouseLeave={()=>this.handleOut('hover9')}>
                            <img src={hxjfgz} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>唤醒肌肤光泽</div>
                            <div className='rftl_item_msg'>促进毒素排出， 深层清洁皮肤，恢复皮肤的自然新陈代谢和调节能力</div>
                            <div className='rftl_item_hover display_none hover9'>
                                <div className='rftl_item_hover_msg center'>促进毒素排出， 深层清洁皮肤，恢复皮肤的自然新陈代谢和调节能力</div>
                                <div className='rftl_item_title_hover center'>唤醒肌肤光泽</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover10')} onMouseLeave={()=>this.handleOut('hover10')}>
                            <img src={xyxh} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>深化血液循环</div>
                            <div className='rftl_item_msg'>缓解手脚冰凉，腿部疼痛肿胀，疲劳和月经不调</div>
                            <div className='rftl_item_hover display_none hover10'>
                                <div className='rftl_item_hover_msg center'>缓解手脚冰凉，腿部疼痛肿胀，疲劳和月经不调</div>
                                <div className='rftl_item_title_hover center'>深化血液循环</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover11')} onMouseLeave={()=>this.handleOut('hover11')}>
                            <img src={shwstt} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>舒缓外伤疼痛</div>
                            <div className='rftl_item_msg'>用于缓解突发意外外伤造成的疼痛止血，防止红肿/青紫於肿的产生</div>
                            <div className='rftl_item_hover display_none hover11'>
                                <div className='rftl_item_hover_msg center'>用于缓解突发意外外伤造成的疼痛止血，防止红肿/青紫於肿的产生</div>
                                <div className='rftl_item_title_hover center'>舒缓外伤疼痛</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover12')} onMouseLeave={()=>this.handleOut('hover12')}>
                            <img src={bhst} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>疤痕疏通</div>
                            <div className='rftl_item_msg'>疤痕会影响经脉能量的正常流动和信息的正常传输，经脉长期不通， 最终导致脏腑功能紊乱</div>
                            <div className='rftl_item_hover display_none hover12'>
                                <div className='rftl_item_hover_msg center'>疤痕会影响经脉能量的正常流动和信息的正常传输，经脉长期不通， 最终导致脏腑功能紊乱</div>
                                <div className='rftl_item_title_hover center'>疤痕疏通</div>
                            </div>
                        </div>
                    </Col>
                    <Col  lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover13')} onMouseLeave={()=>this.handleOut('hover13')}>
                            <img src={shjrst} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>舒缓肌肉酸痛</div>
                            <div className='rftl_item_msg'>激烈运动、运动强度过高、从事某些辛苦的劳动工作肌肉劳损过度导致肌肉痉挛，造成的肩颈肌肉僵硬</div>
                            <div className='rftl_item_hover display_none hover13'>
                                <div className='rftl_item_hover_msg center'>激烈运动、运动强度过高、从事某些辛苦的劳动工作肌肉劳损过度导致肌肉痉挛，造成的肩颈肌肉僵硬</div>
                                <div className='rftl_item_title_hover center'>舒缓肌肉酸痛</div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <div className='rftl_item' onMouseEnter={()=>this.handleEnter('hover14')} onMouseLeave={()=>this.handleOut('hover14')}>
                            <img src={jhmyxt} className="d-block w-100"/>
                            <div className='rftl_item_title textCenter'>强化免疫系统</div>
                            <div className='rftl_item_msg'>有助于保护细胞膜免受氧化代谢产物的侵害，预防细胞产生毒素和攻击性物质</div>
                            <div className='rftl_item_hover display_none hover14'>
                                <div className='rftl_item_hover_msg center'>有助于保护细胞膜免受氧化代谢产物的侵害，预防细胞产生毒素和攻击性物质</div>
                                <div className='rftl_item_title_hover center'>强化免疫系统</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs="auto" lg={8}>
                        <img className="d-block w-100" src={zxs_sdx} style={{marginTop:'5%'}}/>
                    </Col>
                </Row>
                <Footer/>
                <Fixed/>
            </div>
        )
    }
}

export default Consult;

